import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const SelectChevron = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
  </Icon>
));

export default SelectChevron;
